import { useChat as useContextChat } from '../state/ChatContext';

export const useChat = () => {
    return useContextChat();
};
